import { CommunicationsInbox } from '../CommunicationsInbox/CommunicationsInbox';

export const CommunicationsPage = () => {
  return <CommunicationsInbox />;
};
